






































































































































































































































































































import settings from "@/settings.coffee"
import mutations from "@/gql/mutations.coffee"
import queries from "@/gql/queries.coffee"
import tools from "@/tools.coffee"
import StateComments from "@/components/StateComments.vue"
import EstablishmentStateComments from '@/components/EstablishmentStateComments'
import EstablishmentAllMessage from '@/components/EstablishmentAllMessage'

export default {
    "name": "EstablishmentStateInformationNeeded"
    "components": {StateComments, EstablishmentStateComments, EstablishmentAllMessage}
    "props": {
        "review": {
            "type": Object
        },
    },
    "data": ()->
        return {
            "actions": {}
            "state": null
            "text_fr_temp": ""
            "text_native_temp": ""
            "translation_cost":0
            "modal_show": false
            "modal_editfr_show": false
            "modal_editnative_show": false
            "can_edit": false
            "validators": []
            "modalTimer": 0
            "modalDisableOk": true
        }
    "methods":
        "toClipBoardTextNative": ()->
            #this.$refs.text_native.focus();
            #document.execCommand('copy');
            navigator.clipboard.writeText(@state.data.text_native)
        "toClipBoardTextFr": ()->
            #this.$refs.text_fr.focus();
            #document.execCommand('copy');
            navigator.clipboard.writeText(@state.data.text_fr)
        "answer_not_ok": ()->
            @state.data.internal='modifiy_answer'
            @can_edit = true
        "translation_not_ok": ()->
            @state.data.internal='translation_not_ok'
            @can_edit = true
        "modal_ok": ()->
            @modal_show = false
            @classifyReview()
        "modal_cancel": ()->
            @modal_show = false
        
        "save_modification": ()->
            # reset internal state
            if @state.data.internal == 'modifiy_answer'
                @state.data.internal="is_answer_ok"
            if @state.data.internal == 'translation_not_ok'
                @state.data.internal="i_need_translation"
            @can_edit = false

            # update state data
            @update_data()
        
        "update_data": (comments)->
            if comments?
                @state.data.comments = comments
            serialized = JSON.stringify(@state.data)
            serialized = tools.b64_encode(serialized)
            ret = await mutations.run("update_state_data", [@state.uid, serialized])
            console.log("ret", ret)
            @$emit("state-updated")
            return
        
        "notifyConsultant": ()->
            @state.data["internal"] = "is_answer_ok"
        

        "validate": ()->
            # always called before changing state
            @state.data.validated_by = @$store.state.profile.data.fullname
            # keep changes
            await @update_data()

        "classifyReview": ()->
            await mutations.run("gql_mutation_state_call_action", [
                @state.uid, "perfect_i_will_publish_myself"])
            # add validation information
            validated = @validate()
            # leave the state
            #@$router.push("/g/"+@$route.params.establishment_uid)
            @$emit("goto_review_list")
        "answerAccepted": ()->
            self = @
            self.state.data.accepted_by_establishment = true
            await mutations.run("gql_mutation_state_call_action", [
                @state.uid, "accept_answer"])

            # add validation information
            validated = @validate()
            
            # leave the state
            #@$router.push("/g/"+@$route.params.establishment_uid)
            @$emit("goto_review_list")
        "toTranslate": ()->
            self = @
            
            # add validation information
            validated = @validate()

            # leave the state
            mutations.run("gql_mutation_state_call_action", [
                @state.uid, "ask_translation_to_mhr"])
            .then ()->
                self.$router.push("/g/"+self.$route.params.establishment_uid)
        
        "incrModelTimer": ()->
            if @modalTimer > 4
                @modalDisableOk = false
            else
                @modalTimer += 1
                setTimeout(@incrModelTimer, 1000)
        "notifyIpublishMySelf": ()->
            @modal_show = true
            @modalDisableOk = true
            @modalTimer = 0
            @incrModelTimer()
        "get_translation_cost": ()->
            self = @
            queries.run('get_translation_cost', [@review.native_lang.uid, @state.data.text_fr])
            .then (resp)->
                self.translation_cost = resp.body.data.translation_cost.cost
                
                # update internal state
                self.state.data.translation_price = self.translation_cost
                self.state.data.translation_price_accepted = true
                self.state.data.mhr_translate = true

                # save internal state
                self.update_data()
        "i_need_translation": ()->
            @state.data.internal='i_need_translation'
            @get_translation_cost()
    "created": ()->
        self = @
        # convert action list to object & keep only establishment ones
        for action in @review.current_state.list_actions
            if "establishment" in action["groups"]
                @actions[action.slug] = action
        
        @state = @review.current_state
        if @state.data?
            if typeof @state.data == "string"
                @state.data = JSON.parse(@state.data)
            if not @state.data.internal?
                @state.data["internal"] = "is_answer_ok"
            
            if not @state.data.validated_by?
                @state.data.validated_by = null

            if not @state.data.validation_state?
                @state.data.validation_state = []

        # get required validators
        #response = await queries.run("get_establishment_validators", [@review.establishment.uid])
        #if response.ok == true
        #    @validators = response.body.data.establishment.validators

        self.$djangows['onmodelsignals']({"modelName": "state", "appLabel": "state"}, (event)->
            if event.obj?
                if event.obj.uid == self.state.uid
                    if event.signal_type == "post_save" and event.created == false
                        self.state.data.comments = event.obj.data.comments
        )
}   
